import { useTheme } from 'contexts'
import React from 'react'
import { useWindowDimensions } from 'react-native'
import {
  NavigationState,
  TabBar as RNTabBar,
  Route,
  SceneRendererProps,
  TabBarProps,
} from 'react-native-tab-view'

import { Box } from 'widgets/Box'
import { Separator } from 'widgets/Separator/styled'

import { Icon } from '../Icon'
import { Text } from '../Text'

interface CustomNavigationState {
  navigationState: NavigationState<{
    key: string
    title: string
    Component: React.ReactNode
  }>
}

interface Props extends SceneRendererProps, CustomNavigationState {
  actions: React.ReactNode
  hideActions?: boolean
  routeCount: number
  testID?: string
  withIconTabHeaders?: boolean
}

const getTabBarIcon = (route, focused: boolean) => {
  const iconColor = !focused ? 'v2midGrey' : 'v2primary'

  if (route.key === 'feed') {
    return <Icon name='menu' size={20} color={iconColor} />
  }

  if (route.key === 'grid') {
    return <Icon name='menu' size={20} color={iconColor} rotation={90} />
  }

  if (route.key === 'bookmarks') {
    return <Icon name='bookmark' size={20} color={iconColor} />
  }

  return <></>
}

export const TabBar = ({
  actions,
  hideActions,
  routeCount,
  testID,
  withIconTabHeaders = false,
  ...rest
}: Props) => {
  const theme = useTheme()
  const layout = useWindowDimensions()

  let containerWidth: number
  if (layout.width >= theme.maxWidth) {
    containerWidth = theme.maxWidth
  } else {
    containerWidth = layout.width
  }

  if (!routeCount) {
    return null
  }

  const tabsContainerWidth = containerWidth
  const itemWidth = tabsContainerWidth / routeCount
  const numberOfTabs = routeCount || 0
  const tabWidth = numberOfTabs && numberOfTabs > 1 ? itemWidth - theme.spacing.md : 0

  const indicatorStyle = {
    backgroundColor: theme.colors.v2primary,
    width: tabWidth,
    height: 4,
  }

  const labelStyle: TabBarProps<Route>['labelStyle'] = {
    fontSize: 12,
    textTransform: 'capitalize',
    width: tabWidth,
    textAlign: 'center',
  }

  const tabBarStyle = {
    backgroundColor: 'transparent',
    marginRight: 0,
    boxShadow: 'black 0px 1px 1px;',
    marginTop: -10,
  }

  const tabStyle = {
    backgroundColor: 'transparent',
  }

  return (
    <Box
      padding={{ horizontal: 'md' }}
      shadow='md'
      backgroundColor='white'
      flexDirection='row'
      testID={testID}
    >
      <Box flex={1}>
        <RNTabBar
          {...rest}
          style={tabBarStyle}
          tabStyle={tabStyle}
          indicatorStyle={indicatorStyle}
          renderLabel={({ route, focused }) =>
            withIconTabHeaders ? (
              getTabBarIcon(route, focused)
            ) : (
              <Text style={labelStyle} bold={!!focused} color={!focused ? 'v2midGrey' : 'black'}>
                {route.title}
              </Text>
            )
          }
        />
        <Separator />
      </Box>
    </Box>
  )
}
